/// <amd-module name="ExtensionManagement/ManagementHub/ReauthorizeExtensionDialog" />
import * as React from "react";

import { format } from "VSS/Core/Util/String";

import { Dialog } from "VSSUI/Dialog";

import { IExtensionViewModel } from "./UIContracts";

import * as Resources from "ExtensionManagement/ManagementHub/Resources.ExtManagmentHub";
import { IExtensionsService } from "./ExtensionsService";

interface IReauthorizeExtensionDialogProps {
    /**
     * The extension to be authorized
     */
    extension: IExtensionViewModel;

    /**
     * The new permisisons/scope of the extension
     */
    newScopes: string[];

    /**
     * Call back function when user authorizes the extension from dialog
     */
    onContinueReauthorize: () => void;

    /**
     * Callback function on dialog dismiss
     */
    onDismiss: () => void;

    /**
     * Extensions service instance
     */
    extensionService: IExtensionsService;

    /**
     * If user is admin
     */
    userIsAdmin: boolean;
}

/**
 * Dialog that lets user view scope changes for extension
 * only admin can authorize extension update
 */
export class ReauthorizeExtensionDialog extends React.Component<IReauthorizeExtensionDialogProps> {
    public render(): JSX.Element {
        return (
            <Dialog
                titleProps={{ text: format(Resources.AuthorizeExtension, this.props.extension.extensionName) }}
                footerButtonProps={[
                    { text: Resources.Authorize, primary: true, onClick: this.onReauthorize, disabled: !this.props.userIsAdmin },
                    {
                        text: Resources.Cancel,
                        onClick: this.props.onDismiss
                    }
                ]}
                onDismiss={this.props.onDismiss}
            >
                <div className="flex-grow">
                    <p>{format(Resources.ExtensionNewVersionAndPermissionsMessage, this.props.extension.extensionName)}</p>
                    <ul>
                        {this.props.extensionService.getFormattedScopes(this.props.newScopes).map(scope => {
                            return (
                                <li key={scope}>
                                    <b>{scope}</b>
                                </li>
                            );
                        })}
                    </ul>
                    <p>{this.props.userIsAdmin ? Resources.UpdateAndAuthorizeMessage : Resources.DoNotHavePermissions}</p>
                </div>
            </Dialog>
        );
    }

    private onReauthorize = (): void => {
        this.props.onContinueReauthorize();
    };
}
